<template>
  <Alert v-if="errorMsgs && Object.keys(errorMsgs).length" :type="type" show-icon>
    <span v-for="(err, idx) in errorMsgs" :key="idx">
      {{ err }}
    </span>
  </Alert>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'error'
    }
  },

  data () {
    return {
      errorMsgs: null
    }
  },
  methods: {
    resetErrors () {
      this.errorMsgs = ''
    },
    showErrors (data = null) {
      if (data) {
        if (data.data.message) {
          this.errorMsgs = {
            message: data.data.message
          }
        } else {
          this.errorMsgs = data.data
        }
      } else {
        this.errorMsgs = null
      }
    }
  }
}
</script>
